/**
 * Billing Detail 通用搜索参数处理
 * @param data vue data
 * @param page 页码
 */
export const handleSearchParams = (data, page) => {
  const temp = JSON.parse(JSON.stringify(data.filter));
  if (page) {
    temp.page = page;
  }
  temp.advertiserOfferIdList = undefined;
  temp.advertiserOfferNameList = undefined;
  temp.offerIdList = undefined;
  temp.offerNameList = undefined;
  temp.pkgNameList = undefined;
  temp.amList = undefined;
  temp.pmList = undefined;
  temp.bdList = undefined;
  temp.affiliateNameList = undefined;

  if (data.advertiserOfferIdList != null && data.advertiserOfferIdList !== '') {
    temp.advertiserOfferIdList = data.advertiserOfferIdList.split(',');
  }
  if (data.advertiserOfferNameList != null && data.advertiserOfferNameList !== '') {
    temp.advertiserOfferNameList = data.advertiserOfferNameList.split(',');
  }
  if (data.offerIdList != null && data.offerIdList !== '') {
    temp.offerIdList = data.offerIdList.split(',');
  }
  if (data.offerNameList != null && data.offerNameList !== '') {
    temp.offerNameList = data.offerNameList.split(',');
  }
  if (data.pkgNameList != null && data.pkgNameList !== '') {
    temp.pkgNameList = data.pkgNameList.split(',');
  }
  if (temp.affiliateIdList !== undefined && temp.affiliateIdList.length === 0) {
    temp.affiliateIdList = undefined;
  }

  temp.groupItems = [];
  if (data.affIntegrationTypeChecked) {
    temp.groupItems.push('affiliate_integration_type');
  }
  if (data.advIntegrationTypeChecked) {
    temp.groupItems.push('advertiser_integration_type');
  }
  if (data.networkPartnerIdChecked) {
    temp.groupItems.push('network_partner_id');
  }
  if (data.affiliateChecked) {
    temp.groupItems.push('affiliate_id');
    temp.groupItems.push('affiliate_name');
  }
  if (data.agencyPartnerIdChecked) {
    temp.groupItems.push('agency_partner_id');
  }
  if (data.advertiserOfferIdChecked) {
    temp.groupItems.push('advertiser_offer_id');
  }
  if (data.advertiserOfferNameChecked) {
    temp.groupItems.push('advertiser_offer_name');
  }
  if (data.offerIdChecked) {
    temp.groupItems.push('offer_id');
  }
  if (data.offerNameChecked) {
    temp.groupItems.push('offer_name');
  }
  if (data.pkgNameChecked) {
    temp.groupItems.push('pkg_name');
  }
  if (data.advertiserIdChecked) {
    temp.groupItems.push('advertiser_id');
  }
  if (data.advertiserNameChecked) {
    temp.groupItems.push('advertiser_name');
  }
  if (data.pmChecked) {
    temp.groupItems.push('advertiser_pm');
  }
  if (data.bdChecked) {
    temp.groupItems.push('advertiser_bd');
  }
  if (data.advFinancialStatusChecked) {
    temp.groupItems.push('advertiser_financial_status');
  }
  if (data.affFinancialStatusChecked) {
    temp.groupItems.push('affiliate_financial_status');
  }
  if (data.countryChecked) {
    temp.groupItems.push('country');
  }
  if (data.affBillingAppStatusChecked) {
    temp.groupItems.push('aff_billing_app_status');
  }
  if (data.advInvoiceAppStatusChecked) {
    temp.groupItems.push('adv_invoice_app_status');
  }
  temp.groupItems.push('record_date');
  console.log(temp);
  return temp;
};

/**
 * Billing Detail 汇总数据 table 属性映射
 */
export const totalInfoPropertyMap = {
  actualProfit: 'totalActualProfit',
  conversion: 'totalConversion',
  revenue: 'totalRevenue',
  advertiserConversion: 'totalAdvConversion',
  advertiserDeductionConversion: 'totalAdvDeductionConversion',
  advertiserRevenue: 'totalAdvRevenue',
  advertiserDeductionAmount: 'totalAdvDeductionAmount',
  advertiserConfirmedConversion: 'totalAdvConfirmedConversion',
  advertiserConfirmedAmount: 'totalAdvConfirmedAmount',
  advertiserCoverAmount: 'totalAdvCoverAmount',
  advertiserHedgeAmount: 'totalAdvHedgeAmount',
  advPaymentRate: 'totalAdvPaymentRate',
  advertiserActualAmount: 'totalAdvActualAmount',
  affiliateConversion: 'totalAffConversion',
  affiliateConfirmedConversion: 'totalAffConfirmedConversion',
  affiliateRevenue: 'totalAffRevenue',
  affiliateDeductionConversion: 'totalAffDeductionConversion',
  affiliateDeductionAmount: 'totalAffDeductionAmount',
  affiliateCoverAmount: 'totalAffCoverAmount',
  affiliateHedgeAmount: 'totalAffHedgeAmount',
  affiliateConfirmedAmount: 'totalAffConfirmedAmount',
  affPaymentRate: 'totalAffPaymentRate',
  affiliateActualAmount: 'totalAffActualAmount',
  estimatedProfit: 'totalEstimatedProfit',
  estimatedProfitRate: 'totalEstimatedProfitRate',
  actualProfitRate: 'totalActualProfitRate',
};
